module.exports = __webpack_public_path__ + "static/media/add.c299cbd2.svg";